import { render, staticRenderFns } from "./OrderFabric.vue?vue&type=template&id=4d50b666&"
import script from "./OrderFabric.vue?vue&type=script&lang=js&"
export * from "./OrderFabric.vue?vue&type=script&lang=js&"
import style0 from "./OrderFabric.vue?vue&type=style&index=0&id=4d50b666&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports